var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotaActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1631_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.85714 1.3125V2.625H1.92857C0.863839 2.625 0 3.50684 0 4.59375V6.5625H18V4.59375C18 3.50684 17.1362 2.625 16.0714 2.625H14.1429V1.3125C14.1429 0.586523 13.5683 0 12.8571 0C12.146 0 11.5714 0.586523 11.5714 1.3125V2.625H6.42857V1.3125C6.42857 0.586523 5.85402 0 5.14286 0C4.4317 0 3.85714 0.586523 3.85714 1.3125ZM18 7.875H0V19.0312C0 20.1182 0.863839 21 1.92857 21H16.0714C17.1362 21 18 20.1182 18 19.0312V7.875ZM3.85714 12.1406C3.85714 11.5951 4.28705 11.1562 4.82143 11.1562H13.1786C13.7129 11.1562 14.1429 11.5951 14.1429 12.1406C14.1429 12.6861 13.7129 13.125 13.1786 13.125H4.82143C4.28705 13.125 3.85714 12.6861 3.85714 12.1406ZM4.82143 15.0938H9.32143C9.8558 15.0938 10.2857 15.5326 10.2857 16.0781C10.2857 16.6236 9.8558 17.0625 9.32143 17.0625H4.82143C4.28705 17.0625 3.85714 16.6236 3.85714 16.0781C3.85714 15.5326 4.28705 15.0938 4.82143 15.0938Z",
    fill: "#2563eb"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1631_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotaActive);
export default __webpack_public_path__ + "static/media/rota-active.b249a3c2e9e85919d7285ccfaf6f0ab7.svg";
export { ForwardRef as ReactComponent };